module.exports = __webpack_public_path__ + "621f788ace7ecdf18eefb219fd95e62b.jpg";